import layoutBg from '../../Images/complaint-bg.svg'
import ComplaintCards from '../complaint-cards'

const ComplaintBoard = () => {

  return (
    <div className='py-12 bg-secondary dark:bg-dark-box 
                    media dark:text-dark-text'
    style={{
      backgroundImage: `url(${layoutBg})`,
      backgroundPosition: 'top',
      width: '100%',
    }}
    >

      <main className='xxl:flex gap-12 items-center justify-between'>
        <section className='w-full xxl:w-[45%] mb-8 xxl:mb-0 text-center xxl:text-left'>
          <h1 className='text-xl font-bold text-black'>
            Taraplaryň Türkmenistanyň kazyýetleriniň çözgütlerine, hökümlerine
            we gaýry kararlaryna şikaýat  etmäge  hukugy  bardyr.
          </h1>
          <p className='mt-4 mb-8 text-black'>
            (Türkmenistanyň Konstitusiýasy, 105-nji madda)
          </p>
        </section>
        <section className='w-full xxl:w-[55%]'>
          <ComplaintCards />
        </section>
      </main>
    </div>
  )
}

export default ComplaintBoard